import { connect } from 'react-redux';
import { LocationSearch } from './location-search/location-search.component';
import {
  locationSearch,
  orgSearch,
  userLocationsSearch,
} from '../../../redux/actions/location/location-search';
import { userSearch } from '../../../redux/actions/users';

export const LocationSearchContainer = connect(
  (state: any) => ({
    loading:
      state.locationSearch.loading ||
      state.locationSearch.isLocationLoading ||
      state.locationSearch.isOrgLoading ||
      state.userSearch.loading,
    locations: state.locationSearch.locations,
    userSearchResults: state.userSearch.data,
    userLocations: state.locationSearch.userLocations,
    orgs: state.locationSearch.orgs,
  }),
  {
    locationSearch,
    userSearch,
    userLocationsSearch,
    orgSearch,
  }
)(LocationSearch);
